import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-field-type-string",
  "use": "icon-field-type-string-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-field-type-string\">\n  <path d=\"M12.6633 4.63089V3.29785H3.33203V4.63089\" stroke=\"currentColor\" stroke-width=\"1.06667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n  <path d=\"M7.99906 3.29785V12.6292M7.99906 12.6292H6.66602M7.99906 12.6292H9.3321\" stroke=\"currentColor\" stroke-width=\"1.06667\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol